import { ReactComponent as ErrorIcon } from '../../../../icons/error.svg';

import { OkDialog } from '../ok-dialog/OkDialog';

export const ErrorDialog = ({ isOpen, title, message, onClick, onClose }) => (
  <OkDialog
    isOpen={isOpen}
    title={title}
    message={message}
    onClick={onClick}
    onClose={onClose}
    icon={<ErrorIcon width={56} height={56} style={{ color: '#f44336' }} />}
  />
);
